<template>
  <div>
    <h1>Konto wird überprüft</h1>

    <el-card>
      <el-alert
        :closable="false"
        show-icon
        title="Vielen Dank für das Ausfüllen Ihres Profils."
        type="success"
      />

      <el-alert
        :closable="false"
        show-icon
        title="Ihr Konto wurde zur Prüfung an das Landesinstitut übergeben. Sie erhalten eine E-Mail-Benachrichtigung, sobald Ihr Konto freigeschaltet wurde."
        type="warning"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'VSignupPending',

  metaInfo: {
    title: 'Konto wird überprüft'
  }
}
</script>
